// Formats a form into the expected "actions" of the chart
export function useSettingsFormatter(form) {
    const format = (type, value) => {
        const func = `format${type.charAt(0).toUpperCase()}${type.slice(1)}`;

        switch (func) {
            case 'formatLine':
                return formatLine(value);
            case 'formatLineThickness':
                return formatLineThickness(value);
            case 'formatLineColors':
                return formatLineColors(value);
            case 'formatTooltip':
                return formatTooltip(value);
            case 'formatScaleType':
                return formatScaleType(value);
            case 'formatDensity':
                return formatDensity(value);
            case 'formatShowNavigator':
                return formatShowNavigator(value);
            case 'formatCrosshair':
                return formatCrosshair(value);
            case 'formatTrackball':
                return formatTrackball(value);
            case 'formatScaleValue':
                return formatScaleValue(value);
            case 'formatLabels':
                return formatLabels(value);
            case 'formatPreventLabelOverlap':
                return formatPreventLabelOverlap(value);
            case 'formatGridLines':
                return formatGridLines(value);
            case 'formatMinorGridLines':
                return formatMinorGridLines(value);
            case 'formatMarginBars':
                return formatMarginBars(value);
        }
        return;
    };

    const formatLine = (value) => {
        const style = form.value.line;

        const curves = [{
            style,
            lineWidth: form.value.lineThickness,
            colors: form.value.lineColors
        }];

        const action = {
            context: {
                curves,
                id: 'Update',
                index: 0,
                type: 'Symbol'
            },
            id: 'Plot'
        }

        switch(style) {
            case 'CandlestickCloseToClose':
                action.context.curves[0].style = 'Candlestick';
                action.context.curves[0].varyColorPerBar = true;
                action.context.curves[0].attributes = ["ChangeBased"];
                break;
            case 'CandlestickOpenToClose':
                action.context.curves[0].style = 'Candlestick';
                action.context.curves[0].varyColorPerBar = true;
                break;
            case 'HLC':
                action.context.curves[0].varyColorPerBar = true;
                break;
            case 'ColoredOHLC':
                action.context.curves[0].style = 'OHLC';
                action.context.curves[0].attributes = ["ChangeBased"];
                action.context.varyColorPerBar = true;
                break;
            case 'Candlestick':
                action.context.curves[0].colors.push('#000000');
                action.context.curves[0].colors.push('#000000');
                break;
            case 'Line':
                action.context.fields = ['Close', 'Change'];
                break;
            case 'OHLC':
                action.context.varyColorPerBar = false;
                break;
        }

        return action;
    };

    const formatLineThickness = (value) => {
        return formatLine(value);
    };

    const formatLineColors = (value) => {
        return formatLine(value);
    };

    const formatTooltip = (mode) => {
        const tooltipElement = document.getElementById('chart-tooltip');

        // If mode is "price box"
        if (mode === 'standard') {
            if (tooltipElement) {
                tooltipElement.classList.add('hidden');
            }
        } else {
            if (tooltipElement) {
                tooltipElement.classList.remove('hidden');
            }
        }

        return {
            id: 'Tooltip',
            context: {
                visible: true,
                mode
            }
        };
    };

    const formatScaleType = (scale) => {
        return {
            id: 'Scale',
            context: {
                scale
            }
        };
    };

    const formatDensity = (density) => {
        return {
            id: 'Period',
            context: {
                density
            }
        }
    };

    const formatShowNavigator = (showNavigator) => {
        return {
            id: 'Other',
            context: {
                showNavigator
            }
        };
    };

    const formatCrosshair = (crosshair) => {
        return {
            id: 'Crosshair',
            context: {
                crosshair: crosshair === false ? 'none' : crosshair
            }
        };
    };

    const formatTrackball = (plotHover) => {
        return {
            id: 'Other',
            context: {
                plotHover
            }
        }
    };

    const formatScaleValue = (scaleValue) => {
        return {
            id: 'Other',
            context: {
                comparisonMode: scaleValue === 'percentChange' ? 'Percent' : 'None'
            }
        }
    };

    const formatLabels = (label) => {
        return {
            id: 'Other',
            context: {
                showLastValue: label === 'main' ? 'Main' : 'All'
            }
        }
    };

    const formatPreventLabelOverlap = (preventLabelOverlap) => {
        return {
            id: 'Scale',
            context: {
                preventLabelOverlap
            }
        };
    };

    const formatGridLines = (gridLines) => {
        return {
            id: 'Other',
            context: {
                gridLines: gridLines ? 'both' : 'none'
            }
        };
    };

    const formatMinorGridLines = (minorGridLines) => {
        return {
            id: 'Other',
            context: {
                minorGridLines: minorGridLines ? 'both' : 'none'
            }
        };
    };

    const formatMarginBars = (marginBars) => {
        return {
            id: 'Scale',
            context: {
                marginBars
            }
        }
    };

    return {
        format,
        formatLineThickness,
        formatLineColors,
        formatLine,
        formatTooltip,
        formatScaleType,
        formatDensity,
        formatShowNavigator,
        formatCrosshair,
        formatTrackball,
        formatScaleValue,
        formatLabels,
        formatPreventLabelOverlap,
        formatGridLines,
        formatMinorGridLines,
        formatMarginBars
    };
}
